
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import unitModal from "@/components/UnitData.vue";
    import {Param, AccuracyLevel, SurveyRangeVo, Convert} from "@/js/ParamList";

    @Component({
        name: 'measuringDetail',
        components: {ckeditor4, unitModal}
    })
    export default class Home extends Vue {
        @Prop()
        private paramList !: Param[];//传入的测量范围
        @Prop()
        private hideAccuracyLevel!: boolean
        @Prop()
        private params !: any; //附加参数
        symbols = ['～', '<', '≤', '>', '≥'] //符号
        //连接符
        connectors = [
            {text: '用“、”向上合并', val: '、'},
            {text: '用“/“ 向上合并', val: '/'},
            {text: '用“ⅹ”向上合并', val: 'ⅹ'},
            {text: '用“<span class="font-18">˽</span>”向上合并', val: '   '},
            {text: '用“<span class="font-18">↴</span>”向上合并', val: '↴'},
            {text: '用“—”保持本行', val: '—'},
        ]
        unitModal = {//选择测量单位弹出层
            visible: false,
            value: 0,
            index: -1 as number,
            type: '' as string,
        }
        visible = true
        form4 = {
            dataList: [] as SurveyRangeVo[]
        }
        rules = {
            accuracyLevel: [{required: true, message: '请填写不确定度等级', trigger: ['change', 'blur']}],
            upperLimit: [{required: true, message: '请填写范围后值', trigger: ['change', 'blur']}],
        }


        created() {
            let paramList = this.cloneObjectFn(this.paramList);
            let dataList = Convert.paramListToSurveyRangeVo(paramList);
            if(dataList.length == 0){
                dataList = [new SurveyRangeVo()];
            }
            this.form4.dataList = dataList;
        }

        changeConnector(row: any) {
            if (row.connector && row.connector != '—') {
                row.accuracyLevels = [];
            }
        }

        //type: param  paramItem surveyRange  三种类型添加
        addData(dataType: string, paramGroupIndex: number, paramItemGroupIndex: number) {
            const dataList = this.form4.dataList;
            if (paramGroupIndex === -1) {
                //取得最大的那个param的groupIndex
                let maxParamGroupIndex = Math.max.apply(Math, dataList.map(d => {
                    return d.paramGroupIndex
                }));
                paramGroupIndex = maxParamGroupIndex + 1;
            }
            if (paramItemGroupIndex === -1) {
                //取得最大的那个 paramItem 的groupIndex
                const dataListV2 = dataList.filter((data) => data.paramGroupIndex === paramGroupIndex);
                let maxParamItemGroupIndex = Math.max.apply(Math, dataListV2.map(d => {
                    return d.paramItemGroupIndex
                }));
                paramItemGroupIndex = maxParamItemGroupIndex + 1;
            }
            const sr = new SurveyRangeVo();
            sr.dataType = dataType;
            sr.paramGroupIndex = paramGroupIndex;
            sr.paramItemGroupIndex = paramItemGroupIndex;
            dataList.push(sr);
            dataList.sort((a, b) => {
                let r = a.paramGroupIndex - b.paramGroupIndex;
                if (r === 0) {
                    r = a.paramItemGroupIndex - b.paramItemGroupIndex;
                }
                return r;
            });
        }

        isNotHidden(flag: boolean) {
            return flag ? '' : 'hidden';
        }

        delData(index: number, type: string) {
            let dataList = this.form4.dataList;
            const data = dataList[index];
            if (type === 'param') {
                dataList = dataList.filter((d) => d.paramGroupIndex !== data.paramGroupIndex);
                this.form4.dataList = dataList;
            } else if (type === 'paramItem') {
                dataList = dataList.filter((d) => {
                    let flag = true;
                    if (d.paramGroupIndex == data.paramGroupIndex) {
                        if (d.paramItemGroupIndex == data.paramItemGroupIndex) {
                            flag = false;
                        }
                    }
                    return flag;
                });
                this.form4.dataList = dataList;
            } else if (type === 'surveyRange') {
                dataList.splice(index, 1);
            }

        }

        groupByConnector(surveyRangeList: SurveyRangeVo[]) {
            let groupIndex = 1;
            let list = [] as any;
            let dataList = [] as any;
            for (let i = 0; i < surveyRangeList.length; i++) {
                const data = surveyRangeList[i];
                if (i === 0) {
                    list = [data];
                    if (i == (surveyRangeList.length - 1)) {
                        dataList.push(this.cloneData(list));
                    }
                    continue;
                }
                //是否占用一整行
                if (this.isLine(data.connector)) {
                    dataList.push(this.cloneData(list));
                    list = [];
                    groupIndex++;
                }
                list.push(data);
                if (i == (surveyRangeList.length - 1)) {
                    dataList.push(this.cloneData(list));
                    continue;
                }
            }
            return dataList;
        }

        //是否占用一整行
        isLine(connector: string) {
            return connector == '' || connector == '—';
        }

        cloneData(data: any) {
            return JSON.parse(JSON.stringify(data));
        }

        //不确定度 删除
        accuracyLevelDel(accuracyLevels: AccuracyLevel[], index: number) {
            accuracyLevels.splice(index, 1);
        }

        //不确定度 添加
        accuracyLevelAdd(accuracyLevels: AccuracyLevel[]) {
            accuracyLevels.push(new AccuracyLevel());
        }

        //打开选择测量单位弹框
        openUnitModal(index: number, type: string, value: number) {
            this.unitModal.visible = true;
            this.unitModal.index = index;
            this.unitModal.type = type;
            this.unitModal.value = value;
        }

        //修改测量单位
        onUnitModalChange(e: any) {
            const {type, index} = this.unitModal;
            if (index != -1) {
                const surveyRange: SurveyRangeVo = this.form4.dataList[index];
                if (surveyRange) {
                    if (type == "lower") {
                        surveyRange.lowerUnit = e.symbol;
                        surveyRange.lowerUnitId = e.id;
                    } else {
                        surveyRange.upperUnit = e.symbol;
                        surveyRange.upperUnitId = e.id;
                    }
                }
            }
            this.resetUnitModal();
        }

        //重置测量单位弹出框
        resetUnitModal() {
            this.unitModal = {
                visible: false,
                value: 0,
                index: -1,
                type: '',
            }
        }

        //关闭
        closeAddSurveyRanges() {
            this.$emit("closeAddSurveyRanges");
        }

        //提交
        submitAddSurveyRanges() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    const paramList = Convert.surveyRangeVoToParamList(this.form4.dataList);
                    this.$emit("submitSurveyRangesAdd", {
                        params: this.cloneObjectFn(this.params),
                        paramList: this.cloneObjectFn(paramList)
                    });
                } else {
                    this.$message.warning("未填写完整信息");
                }
            });
        }

        objectSpanMethod({rowIndex, columnIndex, row}: any) {
            if (columnIndex == 10) {
                if (row.connector == '' || row.connector == '—') {
                    const dataList = this.form4.dataList.slice(rowIndex, this.form4.dataList.length);
                    const index = dataList.findIndex((a: SurveyRangeVo, index) => index != 0 && (a.connector == '' || a.connector == '—'));
                    let rowCount = 0;
                    if (index === -1) {
                        rowCount = dataList.length;
                    } else {
                        rowCount = index;
                    }
                    if ([10].indexOf(columnIndex) > -1) {
                        return {
                            rowspan: rowCount,
                            colspan: 1
                        };
                    }
                }
            }
        }

        objectRowClass({row, rowIndex}: any) {
            // if(rowIndex != 0 && (row.connector == '' || row.connector == '—')){
            //     return "row-border-top"
            // }
        }

        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }
    }
